import api from './api';

export type GatewayMode = 'test' | 'live';

export interface PaymentGatewayConfig {
  enabled: boolean;
  mode: GatewayMode;
}

export interface RazorpayConfig extends PaymentGatewayConfig {
  keyId: string;
  keySecret: string;
  webhookSecret?: string;
}

export interface PaytmConfig extends PaymentGatewayConfig {
  merchantId: string;
  merchantKey: string;
  website?: string;
  industryTypeId?: string;
}

export interface PhonePeConfig extends PaymentGatewayConfig {
  merchantId: string;
  saltKey: string;
  saltIndex: string;
  redirectUrl?: string;
}

export interface CashfreeConfig extends PaymentGatewayConfig {
  /** Legacy single credential pair — superseded by the mode-specific fields */
  appId: string;
  secretKey: string;
  testAppId?: string;
  testSecretKey?: string;
  liveAppId?: string;
  liveSecretKey?: string;
  /** Webhook signing secret from Cashfree Dashboard → Webhooks (per env) */
  testWebhookSecret?: string;
  liveWebhookSecret?: string;
}

export interface PaymentSettings {
  currency: 'INR';
  freeRidesEnabled: boolean;
  signupFreeCredits: number;
  /** Rupee value of one wallet credit — drives proration and wallet refunds */
  creditValueInr?: number;
  razorpay: RazorpayConfig;
  paytm: PaytmConfig;
  phonepe: PhonePeConfig;
  cashfree: CashfreeConfig;
}

export const DEFAULT_CASHFREE_CONFIG: CashfreeConfig = {
  enabled: false,
  mode: 'test',
  appId: '',
  secretKey: '',
  testAppId: '',
  testSecretKey: '',
  liveAppId: '',
  liveSecretKey: '',
  testWebhookSecret: '',
  liveWebhookSecret: '',
};

export const paymentSettingsService = {
  async getSettings(): Promise<PaymentSettings> {
    const response = await api.get('/payment-settings');
    return response.data;
  },

  async updateSettings(settings: PaymentSettings): Promise<PaymentSettings> {
    const response = await api.put('/payment-settings', settings);
    return response.data;
  }
};
